import React, {useEffect, useState, useRef } from 'react'
import axios from "axios";
import FullCalendar, { formatDate } from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import { INITIAL_EVENTS, createEventId } from './event-utils'
import $ from 'jquery'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const token = localStorage.getItem("token");
const eventsData = [];

function  DemoApp(){
  const [selectedMonth, setSelectedMonth] = useState(new Date());
  const [isLoading, setIsLoading] = useState(false);
  const calendarComponentRef = useRef();

  $(document).ready(function(){
    $('.zhEvent').parent().addClass('top-event');
    $('.dayEvent').parent().addClass('bottom-event');
    $('.fesEvent').parent().addClass('middle-event');
    
  });

   useEffect(()=>{
    loadAllEvents('');
  },[]);

  const [allEvent, setAllEvent] = useState(eventsData); // SUIT
  
  const handleMonthChange = (paypload) => {
    console.log("===>>?>>", paypload)
    loadAllEvents(paypload);
    
  }

  const loadAllEvents = (paypload) => {
    setIsLoading(true)
    if(paypload != ''){
        var newDate =  new Date(paypload.startStr);
        console.log("-------> ", newDate)
        //console.log("====> ", newDate.getFullYear()+'-'+(newDate.getMonth()+1)+'-'+newDate.getDate());
        var php_date = newDate.getFullYear()+'-'+(newDate.getMonth()+1)+'-'+newDate.getDate();
        console.log(php_date);
    } else {
      var php_date = '';
    }
    
  console.log("php_date---->", php_date)   

  const postData = {fdate: php_date};
  console.log("?????=> ", postData)
  axios.post(process.env.REACT_APP_API_KEY+"api/calendar", postData,
    {headers: {
      "Content-type": "Application/json",
      "Accept": "Application/json",
      "Authorization": `Bearer `+token,
      "sellang": localStorage.getItem("selectLang")
      }   
    }).then((res) => {
      var reData = res.data.data; 
      console.log("===> reData ==> ", reData);
      setAllEvent(reData);
      setIsLoading(false)

    }).catch (error => {
      console.log("ERROR: ", error);
    })
}

function loadCustomeData(date){
  var newDate =  new Date(date)
  let calendarApi = calendarComponentRef.current.getApi();
      calendarApi.gotoDate(newDate);

}
    
    return (
      <div className='demo-app'>
        <div className='calendar-box2'>
          <div>{isLoading == true ? <h5 style={{color:'green'}}>Loading...</h5> : ""}</div>
          <div className='d-flex align-items-center'>
          <span className='me-2 cal-span'>Select Month:</span>
          <div className='date-cover date-size'>
           <DatePicker name="sdate" dateFormat = "MM/yyyy" className = "header-datepicker " 
            selected={selectedMonth}
            onChange={(date) => {
              console.log('End: '+date);
              setSelectedMonth(date)
              loadCustomeData(date)
              //handleMonthChange(date)
              
            }}
            showMonthYearPicker
            startDate={new Date("12/31/2022")}
            maxDate={new Date("12/31/2100")}
          />
          </div>
          </div>
        </div>

        <div className='demo-app-main'>
          <FullCalendar
            plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
            headerToolbar={{
              left: '',
              center: 'prev title next',
              right: ''
            }}
            ref={calendarComponentRef}
            initialView='dayGridMonth'
            defaultView= 'year'
            yearColumns= '3'
            handleWindowResize = {true}
            editable={true}
            selectable={true}
            selectMirror={true}
            dayMaxEvents={true}
            events = {allEvent}
            datesSet= {handleMonthChange}
            //loading= {s => toggleLoading(s)}
            // weekends={this.state.weekendsVisible}
            // events = {this.state.currentEvents}
            
          />
        </div>
      </div>

    )
  
}
export default DemoApp